import { Hospital } from 'lucide-react';
import { getProfileColor } from '@/utils';

interface ProfileBadgeProps {
  name: string;
  color?: string;
}

export const ProfileBadge = ({ name, color }: ProfileBadgeProps) => {
  const profileColor = getProfileColor(color || '');

  return (
    <div className="flex items-center gap-2">
      <Hospital className="size-4" style={{ color: profileColor }} />
      <span className="text-sm">{name}</span>
    </div>
  );
};
